import React from "react";
import "./view-menu.css";

import { usePreviewButton } from "../preview-button/preview-button";
import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";
import { useZoomButtons } from "../slideshow-preview/slideshow-preview-zoom-button";
import { useSpreadOverviewButton } from "../spread-overview/spread-overview-button";
import { useIsOverviewMode } from "../../hooks/useIsOverviewMode";
import { FloatingBar } from "../floating-bar";
import { useLabels } from "../../hooks/useLabels";
import { labels } from "./labels";
import { Tooltip } from "../tooltip/tooltip";

export function ViewMenu() {
	const previewProps = usePreviewButton();
	const { zoomInProps, zoomOutProps } = useZoomButtons();
	const spreadOverviewProps = useSpreadOverviewButton();

	const [isPreviewMode] = useIsPreviewMode();
	const [isOverviewMode] = useIsOverviewMode();

	const [[previewTooltipText, zoomInTooltipText, zoomOutTooltipText, spreadOverviewTooltipText]] =
		useLabels([
			labels.previewTooltip,
			labels.zoomInTooltip,
			labels.zoomOutTooltip,
			labels.spreadOverviewTooltip,
		]);

	if (isPreviewMode || isOverviewMode) return null;

	return (
		<div className="view-menu">
			<FloatingBar.Root>
				{previewProps ? (
					<Tooltip text={previewTooltipText}>
						<FloatingBar.Icon {...previewProps} />
					</Tooltip>
				) : null}
				{zoomOutProps ? (
					<Tooltip text={zoomOutTooltipText}>
						<FloatingBar.Icon {...zoomOutProps} />
					</Tooltip>
				) : null}
				{zoomInProps ? (
					<Tooltip text={zoomInTooltipText}>
						<FloatingBar.Icon {...zoomInProps} />
					</Tooltip>
				) : null}
				{spreadOverviewProps ? (
					<Tooltip text={spreadOverviewTooltipText}>
						<FloatingBar.Icon {...spreadOverviewProps} />
					</Tooltip>
				) : null}
			</FloatingBar.Root>
		</div>
	);
}
